<template>
  <button
    ref="recordButton"
    :label="'Record'"
    class="cesium-button cesium-toolbar-button"
    style="padding-top: 4px"
    small
    dark
    @click="toggleRecording"
  >
    <v-icon
      :name="isRecording ? 'stop' : 'circle'"
      scale="1"
      :color="isRecording ? 'white' : 'red'"
      :title="isRecording ? 'Stop recording' : 'Start recording'"
    ></v-icon>
  </button>
</template>

<script>
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

export default {
  name: 'cesium-recorder',
  components: {
    'v-icon': Icon
  },

  data() {
    return {
      isRecording: false,
      chunks: [],
      rec: null,
      stream: null
    }
  },

  computed: {
    cesiumViewer() {
      return this.$parent.viewer
    }
  },

  methods: {
    toggleRecording() {
      if (!this.isRecording) {
        this.startRecording()
      } else {
        this.stopRecording()
      }
      this.isRecording = !this.isRecording
    },

    async startRecording() {
      var options = () => {
        const mimeTypes = [
          'video/webm;codecs=vp9,opus',
          'video/webm;codecs=vp8,opus',
          'video/webm'
        ]
        for (let mimeType of mimeTypes) {
          if (MediaRecorder.isTypeSupported(mimeType)) {
            return { mimeType: mimeType, videoBitsPerSecond: 10e7 }
          }
        }
        throw 'no mime type supported'
      }
      this.stream = this.cesiumViewer.scene.canvas.captureStream(60)
      this.rec = new MediaRecorder(this.stream, options())
      this.rec.ondataavailable = this.addChunk
      this.rec.onStop = (e) => this.stopRecording(e)
      this.rec.start(1000)
    },

    addChunk(e) {
      if (e.data && e.data.size > 0) {
        this.chunks.push(e.data)
      }
    },

    async stopRecording() {
      const blob = new Blob(this.chunks, {
        type: 'video/webm'
      })
      let url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'
      a.href = url
      a.download = 'Recording.webm'
      a.click()
      window.URL.revokeObjectURL(url)
      this.stream.getTracks().forEach((track) => track.stop())
      this.rec.removeEventListener('ondataavailable', this.addChunk)
      document.body.removeChild(a)
    }
  }
}
</script>

<style></style>
